import styled, { css } from "styled-components";

import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const PairingGuideWrapper = styled.div<{ isWineDetailsPage: boolean }>`
  background-color: ${colors.peach};
  padding: ${(props) => (props.isWineDetailsPage ? "40px 80px" : "32px 15px")};

  ${breakpoints.smDown} {
    padding: 32px 15px;
  }
`;

export const PairingGuideTitle = styled.div<{ isWineDetailsPage: boolean }>`
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 24px;

  ${(props) => props.isWineDetailsPage && "margin-bottom: 24px"};

  ${breakpoints.smDown} {
    font-size: 35px;
    line-height: 35px;
  }
`;

export const TextWrapper = styled.div<{
  isOpen: boolean;
  isPairingDescriptionLong: boolean;
}>`
  overflow: hidden;
  margin-bottom: ${(props) => (!props.isPairingDescriptionLong ? 32 : 16)}px;
  height: ${(props) => (props.isOpen || !props.isPairingDescriptionLong ? "auto" : "125px")};
  ${(props) =>
    !props.isOpen &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    `};

  ${breakpoints.smDown} {
    height: ${(props) => (props.isOpen ? "auto" : "100px")};
  }
`;

export const PairingDescription = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-size: 18px;
  line-height: 25px;

  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const SeeMore = styled.div`
  cursor: pointer;
  font-family: ${fonts.fontBauMedium};
  text-align: center;
  text-decoration-line: underline;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 32px;

  ${breakpoints.smDown} {
    font-size: 12px;
    line-height: 17px;
  }
`;
